module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-03.1@2x.254ac7a7.jpg";